<template>
  <div id="app">
    <component :is="layout"> </component>
  </div>
</template>

<script>
  import layout from "@/layout";
  import defaultLayout from "@/layout/defaultLayout";

  export default {
    name: "App",
    created() {},
    components: {
      layout,
      defaultLayout,
    },
    methods: {},
    computed: {
      layout() {
       return this.$route.meta.layout || defaultLayout;
      },
    },
  };
</script>

<style>
  *{
    box-sizing: border-box;
  }
	html,body {
		width: 100%;
    height: 100%;
	}
  #app{
    min-width: 1300px;
  }
	.page-main .el-scrollbar__wrap {
		overflow-x: hidden;
		margin-bottom: 0!important;
	}
	[v-cloak]{
		display: none!important;
	}
	.el-dropdown-menu__item {
		white-space: nowrap;
	}
</style>
